import { StateContext } from '@ngxs/store';
import { reduce as _reduce } from 'lodash-es';

/**
 * Creates entities and collection ids and patch state
 *
 * @param ctx - state context
 * @param payload - array of the entities
 * @param shouldBeStateReset - should the state be updated (shouldBeStateReset = false) or rewritten (shouldBeStateReset = true)
 */
export function patchIdsAndEntities(ctx: StateContext<any>, payload: any[], shouldBeStateReset = true, idFieldName = 'id') {
  let initialValue;

  if (shouldBeStateReset) {
    initialValue = { entities: {}, ids: [] };
  } else {
    const { entities, ids } = ctx.getState();
    initialValue = { entities, ids };
  }

  const res = _reduce(
    payload,
    (acc, entity) => ({
      entities: {
        ...acc.entities,
        [entity[idFieldName]]: {
          ...acc.entities[entity[idFieldName]],
          ...entity,
        },
      },
      ids: acc.ids.indexOf(entity[idFieldName]) === -1 && acc.ids.indexOf(initialValue.entities[idFieldName]) === -1 ? [...acc.ids, entity[idFieldName]] : acc.ids,
    }),
    initialValue,
  );

  return ctx.patchState(res);
}
